(function () {
  'use strict';

  const storageKey = 'cfmShopAttributionV1';
  const sessionKey = 'cfmShopAttributionAppliedV1';
  const attributionDays = 30;
  const keys = [
    'cfm_ad_id',
    'cfm_placement',
    'cfm_variant',
    'cfm_creative',
    'cfm_product',
    'cfm_plan',
    'cfm_entry',
    'cfm_bucket',
  ];

  function readStorage(storage, key) {
    try {
      return storage ? storage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      if (storage) storage.setItem(key, value);
    } catch (error) {}
  }

  function clean(value, maxLength = 191) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9._-]+/g, '-')
      .replace(/^[-.]+|[-.]+$/g, '')
      .slice(0, maxLength);
  }

  function incomingAttribution() {
    const params = new URLSearchParams(window.location.search);
    const attribution = {};
    keys.forEach((key) => {
      const value = clean(params.get(key));
      if (value) attribution[key] = value;
    });

    if (!attribution.cfm_ad_id || !attribution.cfm_placement || !attribution.cfm_variant) {
      return null;
    }

    attribution.captured_at = Date.now();
    return attribution;
  }

  function storedAttribution() {
    try {
      const parsed = JSON.parse(readStorage(window.localStorage, storageKey) || 'null');
      if (!parsed || !parsed.captured_at || Date.now() - Number(parsed.captured_at) > attributionDays * 86400000) {
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function cartAttributes(attribution) {
    const attributes = {};
    keys.forEach((key) => {
      if (attribution[key]) {
        // A double-underscore suffix keeps attribution private in Shopify themes.
        attributes[`${key}__`] = attribution[key];
      }
    });
    return attributes;
  }

  async function applyAttribution(attribution, force) {
    const signature = `${attribution.cfm_ad_id}|${attribution.cfm_entry || ''}`;
    if (!force && readStorage(window.sessionStorage, sessionKey) === signature) {
      return;
    }

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ attributes: cartAttributes(attribution) }),
      });
      if (!response.ok) return;

      writeStorage(window.sessionStorage, sessionKey, signature);
      document.documentElement.dataset.cfmShopAttribution = attribution.cfm_ad_id;
    } catch (error) {}
  }

  const incoming = incomingAttribution();
  if (incoming) {
    writeStorage(window.localStorage, storageKey, JSON.stringify(incoming));
    applyAttribution(incoming, true);
    return;
  }

  const stored = storedAttribution();
  if (stored) {
    applyAttribution(stored, false);
  }
})();
